import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TransferAction from "Store/Component/Transfer/TransferAction";
import DispositionChoise from "./DispositionSubChoices";
import Validation from './dispositionSubChoicesValidation'
import { getStates } from 'Store/Organization/States/StatesAction'
import { useParams } from "react-router-dom";
import { CONSTANTS } from "client/utils/constants";
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";
import { formatPrice } from "utils";
import { getAddressDropDownList } from 'Store/Organization/AutoCompleteAddressSearch/AddressSearchAction';
import { getAddressDetails, setAddressDetails } from "Store/Organization/AutoCompleteAddressDetails/AddressDetailsAction";

const DipositionChoiceContainer = (props: any) => {

  //let AssetDispostionFieldRef = props?.AssetDispostionFieldRef
  const { isDispositionValidate } = props
  const dispatch = useDispatch();

  const [addressDropDownListTemp, setAddressDropDownListTemp] = useState<any>();
  const [addressListLoad, setAddressListLoad] = useState<any>();
  const [addressSearchText, setAddressSearchText] = useState<any>();
  const [dispositionSubChoice, setDispositionSubChoice] = useState<any>([]);
  const [cityOption, setCityOption] = useState<any>([])
  const [stateOption, setStateOption] = useState<any>([])
  let setIsDispositionChoiceChanged = props?.setIsDispositionChoiceChanged;
  let isDispositionChoiceChenged = props?.isDispositionChoiceChenged;
 
  const { dispositionData, dispositionSubChoiceList, statesDropDownList, citiesDropDownList, isResetClicked, addressDropDownList, thirdPartyAddressDetails }: any = useSelector((state?: any) => ({
    dispositionData: state.TransferReducer.dispositionList,
    dispositionSubChoiceList: state.DispositionChoiceReducer.dispositionSubChoiceList,
    statesDropDownList: state.StatesReducer.statesDropDownList,
    citiesDropDownList: state.CitiesReducer.dispositionSubChoiceCitiesDropDownList,
    isResetClicked: state.TransferReducer.isResetClicked,
    addressDropDownList: state.AddressDropDownReducer.thirdPartyAddressDropDownList,
    thirdPartyAddressDetails: state.AddressDetailReducer.thirdPartyAddressDetails
  }));

  const dispositionSubChoiceDropdownList = dispositionSubChoiceList?.map((item: any) =>
    ({ label: item.text, key: item.value, ...item })
  );

  useEffect(() => {
    const addDropdownList = addressDropDownList?.map((item: any, index: number) =>
    ({ text: item.description, label: item.description, value: item.place_id, key: item.place_id })
  );
   setAddressDropDownListTemp(addDropdownList)
   setAddressListLoad(false)
  },[addressDropDownList])

  useEffect(() => {
    setDispositionSubChoice([]);
    setThirdPartyAddress(initialThirdPartyAddress);
  }, [dispositionData.assetDispositionChoice])

  useEffect(() => {
    if (isResetClicked) {
      setDispositionSubChoice([]);
    }
    if(isDispositionChoiceChenged){
      setDispositionSubChoice([]);
      setIsDispositionChoiceChanged(false)
    }
    setAddressSearchText("")
    setAddressDropDownListTemp([])
    dispatch(setAddressDetails({}, 'thirdParty'))
  }, [isResetClicked, isDispositionChoiceChenged])

  const getOptions = (item: any) => ({
    ...item,
    label: item.text,
    value: item.text,
    key: parseInt(item.value)
  })

  let { id } = useParams();

  useEffect(() => {
    if (id) {
      updateAllState();
    }
  }, [])
  useEffect(() => {
    if (id) {
      updateAllState();
    }
  }, [dispositionData?.assetDispositionName])

  useEffect(() => {
    if (props.isRevertChanges) {
      updateAllState();
      props.setIsRevertChanges(false)
    }
  }, [props.isRevertChanges])

  useEffect(() => {
    if (statesDropDownList?.length > 0) {
      const options: any = statesDropDownList.map((item: any) => (
        getOptions(item)
      ))
      setStateOption(options)
    }
  }, [statesDropDownList])

  useEffect(() => {
    if (citiesDropDownList?.length > 0) {
      const options: any = citiesDropDownList.map((item: any) => (
        getOptions(item)
      ))
      setCityOption(options)
    }
  }, [citiesDropDownList])

    const updateAllState = () => {
        if (dispositionData?.assetDispositionChoice === CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_LEASED
            || dispositionData?.assetDispositionChoice === CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_OWNED) {
            setDispositionSubChoice({
                ...dispositionSubChoice, subChoice: {
                    label: dispositionData?.assetDispositionSubChoice,
                    key: dispositionData?.assetDispositionSubChoiceId,
                    value: dispositionData?.assetDispositionSubChoiceId,
                    text: dispositionData?.assetDispositionSubChoice
                }
            })
        }
        if (dispositionData?.assetDispositionChoice === CONSTANTS.DISPOSITION_CHOICES.SELL_TO_LEASED_THIRD_PARTY
            || dispositionData?.assetDispositionChoice === CONSTANTS.DISPOSITION_CHOICES.SELL_TO_OWNED_THIRD_PARTY) {
            setThirdPartyAddress({
                assetDispositionName: dispositionData?.assetDispositionName,
                assetDispositionAddress1: dispositionData?.assetDispositionAddress1,
                assetDispositionAddress2: dispositionData?.assetDispositionAddress2,
                assetDispositionCity: dispositionData?.assetDispositionCity,
                assetDispositionState: dispositionData?.assetDispositionState,
                assetDispositionZip: dispositionData?.assetDispositionZip,
                assetDispositionPhone: dispositionData?.assetDispositionPhone,
                assetDispositionSalePrice: dispositionData?.assetDispositionSalePrice,
                assetDispositionTotalPrice: dispositionData?.assetDispositionTotalPrice
            })
        }

    
  }
  const onChangeDispositionSubChoice = (selectedItem: any) => {
    if (selectedItem?.text === CONSTANTS.DISPOSITION_SUB_CHOICES.THIRD_PARTY) {
      props.AssetDispostionFieldRef?.current[1]?.focus();
    }
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const order = { ...dispositionData, ...initialThirdPartyAddress };
    order.assetDispositionSubChoice = selectedItem.text;
    order.assetDispositionSubChoiceId = selectedItem.value;
    setThirdPartyAddress(initialThirdPartyAddress);
    let error = { ...Validation.ValidateDispositionSubChoice(order, { ...order }) };
    setDispositionSubChoice({ ...dispositionSubChoice, subChoice: selectedItem })
    isDispositionValidate(error)
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...order,
      ...error
    }))
    dispatch(TransferAction.setIsResetClicked(false))
  }

  const initialThirdPartyAddress = {
    assetDispositionName: '',
    assetDispositionAddress1: '',
    assetDispositionAddress2: '',
    assetDispositionCity: '',
    assetDispositionState: '',
    assetDispositionZip: null,
    assetDispositionPhone: null,
    assetDispositionSalePrice: null,
    assetDispositionTotalPrice: null,
  }


  useEffect(() => {
    dispatch(getStates())
  }, [])

  const [thirdPartyAddress, setThirdPartyAddress] = useState<any>(initialThirdPartyAddress)

  const cityOnChange = (e?: any, item?: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const thirdPartyAddressTemp = { ...dispositionData }
    thirdPartyAddressTemp.assetDispositionCity = e.target.value
    let error = { ...Validation.ValidateCity(thirdPartyAddressTemp, { ...thirdPartyAddressTemp }) };
    setThirdPartyAddress(thirdPartyAddressTemp)
    isDispositionValidate(error)
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...thirdPartyAddressTemp,
      ...error
    }))
    dispatch(TransferAction.setIsResetClicked(false))
    setTimeout(()=>{
      if (e.target.name == "assetDispositionCity"){
        props.AssetDispostionFieldRef?.current[7]?.focus();
      }
    },3000)
  }
  const stateOnChange = (e?: any, item?: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const thirdPartyAddressTemp = { ...dispositionData }
    thirdPartyAddressTemp.assetDispositionState = e.target.value
    let error = { ...Validation.ValidateState(thirdPartyAddressTemp, { ...thirdPartyAddressTemp }) };
    setThirdPartyAddress(thirdPartyAddressTemp)
    isDispositionValidate(error)
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...thirdPartyAddressTemp,
      ...error
    }))
    dispatch(TransferAction.setIsResetClicked(false))
    setTimeout(()=>{
      if (e.target.name == "assetDispositionState"){
        props.AssetDispostionFieldRef?.current[5]?.focus();
      }
    },3000)
  }

  const assetDispositionNameOnChange = (e: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const thirdPartyAddressTemp = { ...dispositionData }
    thirdPartyAddressTemp.assetDispositionName = e.target.value
    let error = { ...Validation.ValidateName(thirdPartyAddressTemp, { ...thirdPartyAddressTemp }) };
    setThirdPartyAddress(thirdPartyAddressTemp)
    isDispositionValidate(error)
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...thirdPartyAddressTemp,
      ...error
    }))
    dispatch(TransferAction.setIsResetClicked(false))
    setTimeout(()=>{
      if (e.target.name == CONSTANTS.ASSET_DISPOSITION_NAME){
        props.AssetDispostionFieldRef?.current[3]?.focus();
      }
    },3000)
  }


  const assetDispositionAddress2OnChange = (e: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const thirdPartyAddressTemp = { ...dispositionData }
    thirdPartyAddressTemp.assetDispositionAddress2 = e.target.value
    let error = { ...Validation.ValidateAddress2(thirdPartyAddressTemp, { ...thirdPartyAddressTemp }) };
    setThirdPartyAddress(thirdPartyAddressTemp)
    isDispositionValidate(error)
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...thirdPartyAddressTemp,
      ...error
    }))
    dispatch(TransferAction.setIsResetClicked(false))
    setTimeout(()=>{
      if (e.target.name == CONSTANTS.ASSET_DISPOSITION_ADDRESS2){
        props.AssetDispostionFieldRef?.current[6]?.focus();
      }
    },3000)
  }

  const assetDispositionZipOnChange = (e: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const thirdPartyAddressTemp = { ...dispositionData }
    thirdPartyAddressTemp.assetDispositionZip = e.target.value
    let error = { ...Validation.ValidateZip(thirdPartyAddressTemp, { ...thirdPartyAddressTemp }) };
    setThirdPartyAddress(thirdPartyAddressTemp)
    isDispositionValidate(error)
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...thirdPartyAddressTemp,
      ...error
    }))
    dispatch(TransferAction.setIsResetClicked(false))
    setTimeout(()=>{
      if (e.target.name == CONSTANTS.ASSET_DISPOSITION_ZIP){
        props.AssetDispostionFieldRef?.current[8]?.focus();
      }
    },3000)
  }

  const assetDispositionPhoneOnChange = (value: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const thirdPartyAddressTemp = { ...dispositionData }
    thirdPartyAddressTemp.assetDispositionPhone = value
    let error = { ...Validation.ValidatePhone(thirdPartyAddressTemp, { ...thirdPartyAddressTemp }) };
    setThirdPartyAddress(thirdPartyAddressTemp)
    isDispositionValidate(error)
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...thirdPartyAddressTemp,
      ...error
    }))
    dispatch(TransferAction.setIsResetClicked(false))
  }

  const priceFormat = (item: any) => {
    if (item.target.value == 0){
      return
    }
    const thirdPartyAddressTemp = { ...dispositionData }
    thirdPartyAddressTemp.assetDispositionSalePrice = formatPrice(item.target.value, 2)
    if(thirdPartyAddressTemp.assetDispositionTotalPrice){
      thirdPartyAddressTemp.assetDispositionTotalPrice = formatPrice((thirdPartyAddressTemp.assetDispositionTotalPrice), 2)
    }
    setThirdPartyAddress(thirdPartyAddressTemp)
  };

  const TotalpriceFormat = (item: any) => {
    if (item.target.value == 0){
      return
    }
    const thirdPartyAddressTemp = { ...dispositionData }
    thirdPartyAddressTemp.assetDispositionTotalPrice = formatPrice(item.target.value, 2)
    if(thirdPartyAddressTemp.assetDispositionSalePrice){
      thirdPartyAddressTemp.assetDispositionSalePrice = formatPrice(thirdPartyAddressTemp.assetDispositionSalePrice, 2)
    }
    setThirdPartyAddress(thirdPartyAddressTemp)
  };
  
  const assetDispositionSalePriceOnChange = (e: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const thirdPartyAddressTemp = { ...dispositionData }
    thirdPartyAddressTemp.assetDispositionSalePrice = e.target.value
    let error = { ...Validation.ValidateSalePrice(thirdPartyAddressTemp, { ...thirdPartyAddressTemp }) };
    if(thirdPartyAddressTemp.assetDispositionTotalPrice){
      thirdPartyAddressTemp.assetDispositionTotalPrice = formatPrice((thirdPartyAddressTemp.assetDispositionTotalPrice), 2)
    }
    setThirdPartyAddress(thirdPartyAddressTemp)
    isDispositionValidate(error)
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...thirdPartyAddressTemp,
      ...error
    }))
    dispatch(TransferAction.setIsResetClicked(false))
  }

  const assetDispositionTotalPriceOnChange = (e: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const thirdPartyAddressTemp = { ...dispositionData }
    thirdPartyAddressTemp.assetDispositionTotalPrice = e.target.value
    let error = { ...Validation.ValidateTotalPrice(thirdPartyAddressTemp, { ...thirdPartyAddressTemp }) };
    if(thirdPartyAddressTemp.assetDispositionSalePrice){
      thirdPartyAddressTemp.assetDispositionSalePrice = formatPrice((thirdPartyAddressTemp.assetDispositionSalePrice), 2)
    }
    setThirdPartyAddress(thirdPartyAddressTemp)
    isDispositionValidate(error)
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...thirdPartyAddressTemp,
      ...error
    }))
    dispatch(TransferAction.setIsResetClicked(false))
  }

  useEffect(() => {
    if (addressSearchText?.length > 3) {
      setAddressListLoad(true)
      dispatch(getAddressDropDownList(addressSearchText.replace(/[^\w\s]/gi, ""), 'thirdParty'));
    }

  }, [addressSearchText])

  const filterOptionAddress1 = (value: any, action: any, id: any) => {
    if (action.action === "input-change") {
      setAddressSearchText(value);
      const thirdPartyAddressTemp = { ...dispositionData }
    thirdPartyAddressTemp.assetDispositionAddress1 = value
    let error = { ...Validation.ValidateAddress1(thirdPartyAddressTemp, { ...thirdPartyAddressTemp }) };
    setThirdPartyAddress(thirdPartyAddressTemp)
    isDispositionValidate(error)
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...thirdPartyAddressTemp,
      ...error
    }))
    }
  };

  const assetDispositionAddress1OnChange = (e: any, item?: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    dispatch(getAddressDetails(e?.key, 'thirdParty'))
    dispatch(TransferAction.setIsResetClicked(false))
  }

  useEffect(() => {
    if (thirdPartyAddressDetails?.hasOwnProperty("address1") || thirdPartyAddressDetails?.hasOwnProperty("address2")) {
      setAddressSearchText('')
      let thirdPartyAddressTemp = { ...dispositionData }
      thirdPartyAddressTemp.assetDispositionAddress1 = thirdPartyAddressDetails?.address1
      thirdPartyAddressTemp = { ...Validation.ValidateAddress1(thirdPartyAddressTemp, { ...thirdPartyAddressTemp }) };
      thirdPartyAddressTemp.assetDispositionAddress2 = thirdPartyAddressDetails?.address2
      thirdPartyAddressTemp = { ...Validation.ValidateAddress2(thirdPartyAddressTemp, { ...thirdPartyAddressTemp }) };
      thirdPartyAddressTemp.assetDispositionZip = thirdPartyAddressDetails?.postalCode
      thirdPartyAddressTemp = { ...Validation.ValidateZip(thirdPartyAddressTemp, { ...thirdPartyAddressTemp }) };
      thirdPartyAddressTemp.assetDispositionCity = thirdPartyAddressDetails?.city
      thirdPartyAddressTemp = { ...Validation.ValidateCity(thirdPartyAddressTemp, { ...thirdPartyAddressTemp }) };
      thirdPartyAddressTemp.assetDispositionState = thirdPartyAddressDetails?.state
      thirdPartyAddressTemp = { ...Validation.ValidateState(thirdPartyAddressTemp, { ...thirdPartyAddressTemp }) };
      isDispositionValidate(thirdPartyAddressTemp)
      setThirdPartyAddress(thirdPartyAddressTemp)
      dispatch(TransferAction.setIDisposition(thirdPartyAddressTemp))
      dispatch(setAddressDetails({}, 'thirdParty'))
    }
  }, [thirdPartyAddressDetails])

  return (
    <DispositionChoise
      dispositionSubChoiceDropdownList={dispositionSubChoiceDropdownList}
      onChangeDispositionSubChoice={onChangeDispositionSubChoice}
      dispositionSubChoice={dispositionSubChoice}
      dispositionData={dispositionData}
      cityOption={cityOption}
      cityOnChange={cityOnChange}
      stateOnChange={stateOnChange}
      stateOption={stateOption}
      thirdPartyAddress={thirdPartyAddress}
      assetDispositionNameOnChange={assetDispositionNameOnChange}
      assetDispositionAddress1OnChange={assetDispositionAddress1OnChange}
      assetDispositionAddress2OnChange={assetDispositionAddress2OnChange}
      assetDispositionZipOnChange={assetDispositionZipOnChange}
      assetDispositionPhoneOnChange={assetDispositionPhoneOnChange}
     // DispositionSubChoiceFieldRef={DispositionSubChoiceFieldRef}
      AssetDispostionFieldRef={props.AssetDispostionFieldRef}
      assetDispositionSalePriceOnChange={assetDispositionSalePriceOnChange}
      priceFormat={priceFormat}
      assetDispositionTotalPriceOnChange={assetDispositionTotalPriceOnChange}
      TotalpriceFormat={TotalpriceFormat}
      filterOptionAddress1 = {filterOptionAddress1}
      addressSearchText = {addressSearchText}
      addressListLoad = {addressListLoad}
      addressDropDownListTemp = {addressDropDownListTemp}
    />
  )
}

export default DipositionChoiceContainer